import Model, { attr, belongsTo } from '@ember-data/model';
import { validator, buildValidations } from '@eflexsystems/ember-tracked-validations';
import { AlignmentTypes } from 'eflex/constants/work-instructions/tool-props';

@buildValidations({
  alignment: [validator('inclusion', { in: AlignmentTypes.options })],
})
class WieConfigText extends Model {
  @belongsTo('wie-config/font', { inverse: null, async: false, embedded: true }) font;
  @belongsTo('wie-config/stroke', { inverse: null, async: false, embedded: true }) stroke;
  @belongsTo('wie-config/fill', { inverse: null, async: false, embedded: true }) background;
  @belongsTo('wie-config/fill', { inverse: null, async: false, embedded: true }) textBackground;

  @attr('string') alignment;

  get isDirty() {
    return super.isDirty ||
      this.font.isDirty ||
      this.stroke.isDirty ||
      this.background.isDirty ||
      this.textBackground.isDirty;
  }
}

export default WieConfigText;
